/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { resetAll } from 'reducers';
import { getRequestQuestionnaire, ScheduleQuestionFieldResponse } from 'services';

export type State = ApiState<ScheduleQuestionFieldResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchScheduleAppointmentQuestionnaire = createAsyncThunk(
  'get/scheduleAppointmentQuestionnaire',
  async (PayLoad: Record<string, string>) => await getRequestQuestionnaire({ ...PayLoad })
);

export const initialState = {
  isLoading: false,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const scheduleAppointmentQuestionnaireSlice = createSlice({
  name: 'scheduleAppointmentQuestionnaire',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {
    unmountScheduleAppointmentQuestionnaire: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchScheduleAppointmentQuestionnaire.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      fetchScheduleAppointmentQuestionnaire.fulfilled,
      (state, action: PayloadAction<ScheduleQuestionFieldResponse>) => {
        state.isLoading = false;
        state.data = action.payload;
        state.hasLoaded = true;
      }
    );

    builder.addCase(fetchScheduleAppointmentQuestionnaire.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });

    builder.addCase(resetAll, () => initialState);
  },
});

export const stateSelector_ = (state: { scheduleRequestQuestionnaire: State }): State =>
  state.scheduleRequestQuestionnaire;

export const scheduleQuestions_ = createSelector(stateSelector_, (state) => state.data);

export const scheduleQuestionsIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const scheduleQuestionsHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export const { unmountScheduleAppointmentQuestionnaire } = scheduleAppointmentQuestionnaireSlice.actions;

export default scheduleAppointmentQuestionnaireSlice.reducer;
